/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */

import React from 'react';

import IconSlot from './IconSlot';

type SmartLinkBenefitImageImageProps = {
	productIcon?: React.ReactNode;
	providerIcon?: React.ReactNode;
};

const SmartLinkBenefitImage = ({
	productIcon,
	providerIcon,
}: SmartLinkBenefitImageImageProps): JSX.Element => {
	const productIconSlot = <IconSlot icon={productIcon} x={68} y={58} w={24} h={24} />;
	const providerIconSlot = <IconSlot icon={providerIcon} x={98.8} y={217.1} w={20} h={20} />;

	return (
		<svg
			width="100%"
			viewBox="0 0 440 660"
			preserveAspectRatio="xMidYMin meet"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_3120_9396)">
				<g transform="scale(1.3) translate(0, 0)">
					<path
						d="M366.41 476.854C366.44 476.804 366.44 476.714 366.5 476.644C364.75 475.764 364.55 473.604 363.2 472.314L363.15 472.264C361.78 471.824 362.15 470.454 360.45 470.444C360.45 470.444 360.89 470.224 360.9 470.224C358.14 467.484 351.32 460.754 351.32 460.754C351.17 461.364 352.41 460.304 353.66 460.484C353.66 460.484 353.75 460.254 353.84 460.434C357.03 457.324 360.62 456.134 364.7 454.654C366.74 454.104 367.05 448.334 363.56 450.724C363.52 450.684 363.43 450.654 363.39 450.584C362.17 452.004 360.14 451.484 358.6 452.224L358.54 452.254L355.98 453.504C354.59 454.074 352.94 454.524 351.21 454.964C351.26 454.914 351.31 454.864 351.36 454.814C351.36 454.814 351.54 452.044 351.49 450.674C351.49 450.674 353.24 448.474 352.66 446.964C353.65 445.194 357.17 441.324 353.97 440.224C352.92 440.224 352.1 439.314 351.74 441.004C351.68 440.994 351.6 441.014 351.52 440.984C351.33 442.734 349.26 443.974 348.69 445.634L348.67 445.704C348.81 447.124 347.71 448.524 347.7 448.524C347.18 449.824 346.5 451.244 345.78 452.724C345.48 451.924 345.15 451.214 344.82 450.704C343.62 449.404 344.13 431.644 339.69 435.564C339.9 438.914 340.96 442.404 340.1 445.384C339.68 445.614 340.32 446.804 340.84 447.774C340.8 449.004 340.55 449.664 340.48 451.424C338.28 449.834 328.68 441.784 329.27 447.204C330.3 447.754 331.05 448.384 331.59 449.664C332.09 450.214 336.5 452.694 336.64 453.314C336.35 454.174 341.56 454.864 339.45 455.504C339.76 456.184 340.18 456.834 340.67 457.464C338.39 457.704 335.66 458.374 334.23 459.244C333.98 459.674 324.88 460.254 321.58 462.384C319.61 463.494 317.87 464.044 319.92 465.714C320.66 465.114 323.44 465.974 323.38 465.184C324.06 465.464 328.66 463.704 329.17 464.004C329.42 464.404 333.04 462.284 332.61 463.284C335.12 463.994 338.18 463.414 341.36 462.604C340.1 464.604 338.86 467.454 338.7 469.224C337.62 471.494 334.77 476.514 333.86 479.594C332.56 481.834 333.01 482.014 334.65 483.164L334.68 483.194C335.02 483.424 334.64 483.194 335.93 483.244C335.8 483.124 335.61 482.604 335.36 482.694C335.53 482.344 337.49 481.844 336.67 481.374C336.64 481.304 337.92 480.324 338.05 479.264C339.19 475.484 341.92 473.574 343.94 469.264C343.89 469.714 347.29 478.184 347.13 482.404C346.88 484.484 351.92 487.584 351.19 482.944C351.25 482.924 351.3 482.844 351.39 482.834C350.58 480.924 351.65 478.954 351.23 477.014L351.21 476.934C350.3 475.754 351.35 474.774 349.91 473.814C349.91 473.814 350.4 473.864 350.41 473.874C349.77 471.124 349.37 467.764 348.77 464.754C350.92 466.704 352.81 468.804 353.59 471.114L353.69 470.964C353.69 471.034 353.84 471.084 353.71 471.244C355.52 471.624 356.14 472.384 357.45 472.894C357.45 472.894 358.85 475.424 360.48 475.514L362.96 479.024C364.03 480.834 369.8 479.794 366.45 476.894L366.41 476.854Z"
						fill="#101214"
					/>
					<rect x="44" y="42" width="417" height="618" rx="12" fill="white" />
					<rect
						width="351.259"
						height="8"
						transform="matrix(1 -2.23478e-05 -0.000671322 1 68.2249 94)"
						fill="#F0F1F2"
					/>
					<rect
						width="351.259"
						height="8"
						transform="matrix(1 -2.23478e-05 -0.000671322 1 68.2126 112.083)"
						fill="#F0F1F2"
					/>
					<rect
						width="107"
						height="8"
						transform="matrix(1 -2.23478e-05 -0.000671322 1 68.2007 130.165)"
						fill="#F0F1F2"
					/>
					<rect
						width="351.259"
						height="8"
						transform="matrix(1 -2.23478e-05 -0.000671322 1 68.2324 385)"
						fill="#F0F1F2"
					/>
					<rect
						width="351.259"
						height="8"
						transform="matrix(1 -2.23478e-05 -0.000671322 1 68.2205 403)"
						fill="#F0F1F2"
					/>
					<rect
						width="271.987"
						height="8"
						transform="matrix(1 -2.23478e-05 -0.000671322 1 68.2083 421)"
						fill="#F0F1F2"
					/>
					<rect
						width="26.8308"
						height="7.5752"
						transform="matrix(0.999993 0.00317261 -0.00509147 0.99999 342.951 94.4097)"
						fill="#D3F1A7"
					/>
					<rect
						width="34.6884"
						height="12.9096"
						transform="matrix(0.999993 0.00317261 -0.00509147 0.99999 370.104 80.0767)"
						fill="#82B536"
					/>
					<path
						d="M368.765 80.1709L370.08 80.1759L369.983 102.033L368.668 102.028L368.765 80.1709Z"
						fill="#82B536"
					/>
					<rect
						width="26.1985"
						height="2.5257"
						transform="matrix(0.999993 0.00317261 -0.00509147 0.99999 373.772 85.4707)"
						fill="#292A2E"
					/>
					<rect
						width="62"
						height="8"
						transform="matrix(1 -0.000310775 -0.000336467 1 100.479 66.0459)"
						fill="#F0F1F2"
					/>
					<rect
						x="0.936372"
						y="0.932176"
						width="75.0083"
						height="15.7741"
						transform="matrix(1.00193 -0.000455984 -0.000532466 0.997369 117.793 233.837)"
						fill="white"
					/>
					<rect
						x="0.936372"
						y="0.932176"
						width="75.0083"
						height="15.7741"
						transform="matrix(1.00193 -0.000455984 -0.000532466 0.997369 117.793 233.837)"
						stroke="#F0F1F2"
						strokeWidth="1.87013"
					/>
					<rect
						x="0.936372"
						y="0.932176"
						width="152.13"
						height="16.1299"
						transform="matrix(1.00193 -0.000455984 -0.000532466 0.997369 192.946 233.803)"
						fill="white"
					/>
					<rect
						x="0.936372"
						y="0.932176"
						width="152.13"
						height="16.1299"
						transform="matrix(1.00193 -0.000455984 -0.000532466 0.997369 192.946 233.803)"
						stroke="#F0F1F2"
						strokeWidth="1.87013"
					/>
					<rect
						width="31"
						height="8"
						transform="matrix(1.00193 -0.000455984 -0.000532466 0.997369 211.886 238.778)"
						fill="#94C748"
					/>
					<rect
						x="0.936372"
						y="0.932176"
						width="75.0083"
						height="15.7741"
						transform="matrix(1.00193 -0.000455984 -0.000532466 0.997369 117.784 249.924)"
						fill="white"
					/>
					<rect
						x="0.936372"
						y="0.932176"
						width="75.0083"
						height="15.7741"
						transform="matrix(1.00193 -0.000455984 -0.000532466 0.997369 117.784 249.924)"
						stroke="#F0F1F2"
						strokeWidth="1.87013"
					/>
					<rect
						x="0.936372"
						y="0.932176"
						width="152.13"
						height="16.1299"
						transform="matrix(1.00193 -0.000455984 -0.000532466 0.997369 192.937 249.89)"
						fill="white"
					/>
					<rect
						x="0.936372"
						y="0.932176"
						width="152.13"
						height="16.1299"
						transform="matrix(1.00193 -0.000455984 -0.000532466 0.997369 192.937 249.89)"
						stroke="#F0F1F2"
						strokeWidth="1.87013"
					/>
					<rect
						width="50"
						height="8"
						transform="matrix(1.00193 -0.000455984 -0.000532466 0.997369 226.663 254.858)"
						fill="#FBD779"
					/>
					<rect
						x="0.936372"
						y="0.932176"
						width="74.805"
						height="14.961"
						transform="matrix(1.00193 -0.000455984 -0.000532466 0.997369 117.776 266.012)"
						fill="white"
					/>
					<rect
						x="0.936372"
						y="0.932176"
						width="74.805"
						height="14.961"
						transform="matrix(1.00193 -0.000455984 -0.000532466 0.997369 117.776 266.012)"
						stroke="#F0F1F2"
						strokeWidth="1.87013"
					/>
					<rect
						x="0.936372"
						y="0.932176"
						width="152.13"
						height="15.1299"
						transform="matrix(1.00193 -0.000455984 -0.000532466 0.997369 192.725 265.977)"
						fill="white"
					/>
					<rect
						x="0.936372"
						y="0.932176"
						width="152.13"
						height="15.1299"
						transform="matrix(1.00193 -0.000455984 -0.000532466 0.997369 192.725 265.977)"
						stroke="#F0F1F2"
						strokeWidth="1.87013"
					/>
					<rect
						width="40"
						height="8"
						transform="matrix(1.00193 -0.000455984 -0.000532466 0.997369 217.979 270.451)"
						fill="#C97CF4"
					/>
					<rect
						x="0.936372"
						y="0.932176"
						width="74.805"
						height="14.961"
						transform="matrix(1.00193 -0.000455984 -0.000532466 0.997369 117.767 281.744)"
						fill="white"
					/>
					<rect
						x="0.936372"
						y="0.932176"
						width="74.805"
						height="14.961"
						transform="matrix(1.00193 -0.000455984 -0.000532466 0.997369 117.767 281.744)"
						stroke="#F0F1F2"
						strokeWidth="1.87013"
					/>
					<rect
						x="0.936372"
						y="0.932176"
						width="152.13"
						height="15.1299"
						transform="matrix(1.00193 -0.000455984 -0.000532466 0.997369 192.717 281.71)"
						fill="white"
					/>
					<rect
						x="0.936372"
						y="0.932176"
						width="152.13"
						height="15.1299"
						transform="matrix(1.00193 -0.000455984 -0.000532466 0.997369 192.717 281.71)"
						stroke="#F0F1F2"
						strokeWidth="1.87013"
					/>
					<rect
						width="40"
						height="8"
						transform="matrix(1.00193 -0.000455984 -0.000532466 0.997369 262.94 286.163)"
						fill="#357DE8"
					/>
					<g clipPath="url(#clip2_3120_9396)">
						<path
							d="M223.554 267.082C223.289 267.367 222.539 267.001 222.639 266.641C222.787 266.127 222.999 265.621 223.339 265.003C223.771 264.319 224.027 264.224 224.276 263.745C224.733 262.944 225.285 261.498 225.416 261.145C225.438 261.092 225.457 261.045 225.493 260.999C225.523 260.949 225.521 260.997 225.564 260.954C225.571 260.942 225.581 260.939 225.582 260.923C225.582 260.923 225.572 260.91 225.569 260.9L225.556 260.893C225.509 260.87 225.462 260.846 225.415 260.822C224.942 260.621 224.374 260.389 223.818 260.195C222.789 259.785 222.154 259.534 221.821 259.405C221.041 259.089 220.483 258.781 219.969 258.415C219.687 258.215 219.976 257.579 220.329 257.63C220.971 257.722 221.594 257.877 222.381 258.181C222.683 258.302 223.405 258.379 224.317 258.706C224.469 258.759 224.609 258.83 224.739 258.92C225.112 259.158 225.543 259.386 225.945 259.574L226.093 259.649C226.18 259.678 226.254 259.715 226.331 259.746C226.499 259.816 226.66 259.882 226.811 259.95C227.121 260.075 227.396 260.183 227.628 260.277C227.337 260.799 227.177 261.097 227.177 261.097C227.177 261.097 225.861 263.422 225.305 264.405C224.914 265.094 224.726 265.426 224.608 265.625C224.255 266.236 223.925 266.69 223.55 267.088L223.554 267.082Z"
							fill="#292A2E"
						/>
						<path
							d="M211.197 241.523C212.078 240.978 212.545 241.643 211.861 242.255C210.914 243.162 210.001 244.175 209.137 245.648C208.645 246.479 208.376 247.02 208.168 247.504C207.953 247.984 207.802 248.415 207.69 249.06C207.488 250.152 207.549 251.652 207.875 252.924C208.02 253.562 208.273 254.135 208.458 254.601C208.696 255.052 208.879 255.404 208.984 255.594C209.058 255.705 209.129 255.821 209.192 255.934C209.397 256.353 210.037 257.478 211.223 258.622C211.797 259.212 212.55 259.749 213.357 260.24C214.182 260.7 215.077 261.115 216 261.35C216.634 261.56 217.235 261.648 217.774 261.752C218.322 261.813 218.805 261.865 219.234 261.89C220.098 261.917 220.732 261.861 221.161 261.813C223.198 261.565 224.664 261.06 226.063 260.448C226.812 260.095 227.271 260.643 226.549 261.172C225.23 262.091 223.63 262.835 221.343 263.124C220.478 263.217 218.562 263.598 215.947 262.954C215.532 262.832 215.106 262.728 214.724 262.534C213.033 261.802 211.304 260.632 210.175 259.525C209.878 259.261 209.626 258.996 209.418 258.745C209.209 258.493 208.995 258.296 208.864 258.092C208.579 257.705 208.407 257.48 208.407 257.48C208.407 257.48 208.346 257.392 208.236 257.24C208.14 257.078 208.003 256.839 207.834 256.551C207.489 255.972 207.111 255.126 206.816 254.168C206.184 252.249 206.242 249.858 206.558 248.501C207.012 246.456 207.592 245.564 207.882 245.017C208.855 243.374 210.003 242.319 211.197 241.523Z"
							fill="#292A2E"
						/>
					</g>
					<rect x="72" y="161" width="347" height="207" rx="6" fill="#8FB8F6" />
					<rect
						x="66.75"
						y="155.75"
						width="348.5"
						height="207.5"
						rx="3.25"
						fill="#F9FBFD"
						stroke="#8FB8F6"
						strokeWidth="1.5"
					/>
					<rect
						width="107"
						height="8"
						transform="matrix(1 -2.23478e-05 -0.000671322 1 103.012 173.165)"
						fill="#D0DEF2"
					/>
					<mask id="path-49-inside-1_3120_9396" fill="white">
						<path d="M103 206H379V362H103V206Z" />
					</mask>
					<path d="M103 206H379V362H103V206Z" fill="white" />
					<path
						d="M103 206V205H102V206H103ZM379 206H380V205H379V206ZM103 206V207H379V206V205H103V206ZM379 206H378V362H379H380V206H379ZM103 362H104V206H103H102V362H103Z"
						fill="#0B120E"
						fillOpacity="0.14"
						mask="url(#path-49-inside-1_3120_9396)"
					/>
					<rect
						width="107"
						height="8"
						transform="matrix(1 -2.23478e-05 -0.000671322 1 121.005 224.002)"
						fill="#6B6E76"
					/>
					<rect
						width="237.496"
						height="8"
						transform="matrix(1 -2.23478e-05 -0.000671322 1 121.005 242.005)"
						fill="#6B6E76"
					/>
					<rect
						width="237.496"
						height="8"
						transform="matrix(1 -2.23478e-05 -0.000671322 1 121.005 260.005)"
						fill="#6B6E76"
					/>
					<path
						d="M61.3378 122.737C61.6171 122.177 58.1342 113.118 57.2561 115.732C56.801 116.617 57.0322 117.422 58.0247 117.666C56.2623 117.985 59.0352 119.646 58.611 120.492C57.284 120.234 60.4323 122.647 59.0166 122.206C59.6449 132.085 75.9612 151.538 63.6634 127.589C63.5817 130.007 62.6201 127.756 62.6812 126.669C64.6157 128.167 62.2943 123.699 61.5656 122.884C61.8811 124.279 60.2179 122.01 61.3344 122.741L61.3378 122.737Z"
						fill="#101214"
					/>
					<path
						d="M49.5857 140.943C49.2459 139.662 39.2484 134.515 38.2637 133.861C35.9524 132.802 36.384 135.758 38.2594 136.193C38.6122 136.426 41.3136 137.197 40.3497 137.823C41.4171 140.321 46.0137 140.555 46.7236 142.668C47.2511 142.314 48.1137 143.046 48.4778 142.865C48.5362 143.497 49.4685 143.827 49.5152 143.674C52.2908 146.31 54.2499 142.903 50.7524 141.538C50.8676 141.425 50.1541 140.706 49.5943 140.943L49.5857 140.943Z"
						fill="#101214"
					/>
					<path
						d="M39.4701 174.033C41.1809 175.147 39.6046 175.107 38.7741 174.555C39.8901 173.487 36.7954 173.565 36.0723 173.932C36.4066 173.988 36.5682 174.533 35.8805 174.456C36.2338 173.13 27.5479 172.249 31.8883 175.362C32.0358 175.367 32.0059 174.299 32.2092 174.645C32.0627 176.249 33.3227 175.211 33.6952 175.114C33.7617 175.957 34.0569 175.199 34.1847 175.555C33.8165 176.657 35.8605 174.913 35.4289 176C37.5666 177.865 41.2905 175.863 42.9467 177.541C43.8244 175.717 50.427 179.002 47.6545 175.204C44.8439 174.19 42.5606 173.57 39.4701 174.033Z"
						fill="#101214"
					/>
					<path
						d="M21.2561 153.478C20.8018 156.036 26.7133 155.89 28.429 157.072C30.5261 158.735 52.0689 165.506 46.1376 159.992C39.609 157.994 34.4269 155.302 26.3618 153.802C25.0538 153.469 20.9211 151.644 21.2561 153.478Z"
						fill="#101214"
					/>
					<path
						d="M82.7198 134.846C85.0673 136.492 82.5184 138.446 84.4665 139.99C88.1502 142.366 87.5201 123.15 84.0027 123.526C81.095 124.254 83.8998 133.561 82.7198 134.846Z"
						fill="#101214"
					/>
					{productIconSlot}
				</g>
				{providerIconSlot}
			</g>
			<defs>
				<linearGradient
					id="paint0_linear_3120_9396"
					x1="89.6875"
					y1="172.49"
					x2="89.6875"
					y2="177.111"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#1A237E" stopOpacity="0.2" />
					<stop offset="1" stopColor="#1A237E" stopOpacity="0.02" />
				</linearGradient>
				<radialGradient
					id="paint1_radial_3120_9396"
					cx="0"
					cy="0"
					r="1"
					gradientUnits="userSpaceOnUse"
					gradientTransform="translate(77.4644 167.395) scale(24.8062 23.319)"
				>
					<stop stopColor="white" stopOpacity="0.1" />
					<stop offset="1" stopColor="white" stopOpacity="0" />
				</radialGradient>
				<clipPath id="clip0_3120_9396">
					<rect width="440" height="660" fill="white" />
				</clipPath>
				<clipPath id="clip1_3120_9396">
					<rect
						width="24"
						height="24"
						fill="white"
						transform="matrix(1 -0.000310775 -0.000336467 1 68.0081 58.0562)"
					/>
				</clipPath>
				<clipPath id="clip2_3120_9396">
					<rect
						width="18.4543"
						height="24.9028"
						fill="white"
						transform="matrix(-0.507908 0.846939 0.903773 0.454122 212.523 240.466)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default SmartLinkBenefitImage;
